import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSiteConfig } from './hooks/useSiteConfig';
import { IndexView } from './views/IndexView';
import { JobDetailView } from './views/JobDetailView';
import { ContentView } from './views/ContentView';
import { ThankyouView } from './views/ThankyouView';
import { CvuploadView } from './views/CvuploadView';
import { NotfoundView } from './views/NotfoundView';
export function Router() {
    const config = useSiteConfig();
    if (!config)
        return null;
    const ssr = window.__CAREER_CONFIG__;
    const module = ssr?.module || 'index';
    const payload = (ssr?.payload || {});
    switch (module) {
        case 'index':
            return _jsx(IndexView, { config: config });
        case 'job':
            return _jsx(JobDetailView, { config: config, jobId: Number(payload.id) || 0, slug: String(payload.slug || '') });
        case 'content':
            return _jsx(ContentView, { config: config, pageKey: String(payload.key || '') });
        case 'thankyou':
            // F-13: jobId prop törölve — a contact info a page.contact-ból jön a backendből,
            // a job_id-t a backend server-side derive-eli a key-ből (security).
            return _jsx(ThankyouView, { config: config, pageKey: String(payload.key || '') });
        case 'cvupload':
            return _jsx(CvuploadView, { config: config });
        case 'notfound':
        default:
            // [F-CANDTRACK] a reason megkülönbözteti a lejárt hirdetést az általános 404-től
            return _jsx(NotfoundView, { config: config, reason: String(payload.reason || '') });
    }
}
